import { render } from "./FacetPanelYear.vue?vue&type=template&id=a42c321e&scoped=true&ts=true"
import script from "./FacetPanelYear.vue?vue&type=script&lang=ts"
export * from "./FacetPanelYear.vue?vue&type=script&lang=ts"

import "./FacetPanelYear.vue?vue&type=style&index=0&id=a42c321e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a42c321e"]])

export default __exports__